import React from 'react';
import Modal from './Modal';

interface Props {
  title?: string;
  titleUnderline?: boolean;
  visible: boolean;
  close?: () => void;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  buttonText?: string;
  action: () => void;
  actionDisabled?: boolean;
  children: React.ReactNode;
  size?: string;
  customClass?: string;
}

const ConfirmModal = (props: Props) => {
  const {
    title,
    titleUnderline,
    children,
    visible,
    setVisible,
    close,
    buttonText,
    action,
    actionDisabled,
    size,
    customClass,
  } = props;

  const actions = [
    { text: buttonText ? 'Cancel' : 'No' },
    { text: buttonText || 'Yes', action, disabled: actionDisabled },
  ];

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      close={close}
      actions={actions}
      title={title}
      titleUnderline={titleUnderline}
      size={size}
      customClass={customClass}
    >
      {children}
    </Modal>
  );
};

export default ConfirmModal;
